import { defineStore } from 'pinia';
import { httpAPI } from '@/services/ajax';
import app from '@/main.js';

export const useMessengerStore = defineStore('messenger', {
    state: () => ({
        isPanelVisible: false,
        recipientIds: [],
        threadId: null,
        threadUsersId: null,
        activeTab: '',
        newThreadSubject: null,
        newThreadMessage: null,
        isSupportThread: null,
    }),
    actions: {
        openNew(
            recipientIds = [],
            subject = null,
            message = null,
            isSupportThread = false
        ) {
            /**
             * Open the messenger panel to the "New Message" tab
             */

            this.recipientIds = recipientIds;
            this.isPanelVisible = true;
            this.activeTab = 'NEW';
            this.newThreadSubject = subject;
            this.newThreadMessage = message;
            this.isSupportThread = isSupportThread;
        },

        openHistory() {
            this.isPanelVisible = true;
            this.activeTab = 'HISTORY';
        },

        openThread(threadId) {
            this.threadId = threadId;
            this.isPanelVisible = true;
            this.activeTab = 'THREAD';

            // When a thread is opened, it should be marked as read

            const url =
                app.config.globalProperties.$env.apiRoot +
                'message-thread/toggle-read';
            const payload = {
                thread_id: threadId,
                is_marked_read: true,
            };

            httpAPI(
                url,
                payload,
                'POST',
                app.config.globalProperties.$router
            ).then((response) => {
                // mark as read -- do nothing else
            });
        },

        openThreadUsers(threadId) {
            this.threadUsersId = threadId;
            this.isPanelVisible = true;
            this.activeTab = 'THREAD_USERS';
        },

        closePanel() {
            this.isPanelVisible = false;
        },
    },

    getters: {},
});
